import {
  Box,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import SelectedDriver from 'components/selected-driver/selected-driver.component'
import { TripResponse } from 'store/trips/trips.types'
import { tripTaskToPayload } from 'store/trips/trips.utils'
import TripDetailsTable from '../create-trip/trip-details-old/trip-details-table/trip-details-table'

interface TripDetailsProps {
  trip: TripResponse | undefined
  refetch: () => void
}

const TripDetails = ({ trip, refetch }: TripDetailsProps) => {
  const theme = useTheme()
  const isSm = useMediaQuery(theme.breakpoints.down('md'))

  if (!trip) {
    return (
      <Box p={2}>
        <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '0.875rem' }}>
          Please select a trip to see the details.
        </Typography>
      </Box>
    )
  }

  return (
    <Stack
      sx={{
        height: '100%',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Stack
        spacing={isSm ? 2 : 4}
        mx={2}
        mt={2}
        direction={isSm ? 'column' : 'row'}
        sx={{ flexShrink: 0 }}
      >
        <SelectedDriver
          firstDriverName={trip?.firstDriverName}
          secondDriverName={trip?.secondDriverName}
        />
      </Stack>

      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflow: 'auto',
          overscrollBehaviorY: 'contain',
          mt: 1,
        }}
      >
        <TripDetailsTable
          tripTasks={trip.tripTasks.map(tripTaskToPayload)}
          isLandingPage
          onTaskStatusUpdated={refetch}
        />
      </Box>
    </Stack>
  )
}

export default TripDetails
